export const URL_TARGET = '_blank';
